<template>
  <div ref="shareWrapper">
    <button
      id="shareBtn"
      class="btn btn-sm btn-secondary"
      @click="handleShare"
    >
      <i
        aria-hidden="true"
        class="fa fa-share-alt"
      />
      <span class="share_text">{{ $translate("Ecomsilio::Template.shareButtonText") }}
      </span>
    </button>

    <div
      v-show="isShareMenuVisible"
      id="shareMenu"
      class="share-menu"
    >
      <ul ref="shareMenuList">
        <li @click="toggleShareMenu">
          <a
            id="fbShare"
            :href="facebookUrl"
            target="_blank"
          ><i
            aria-hidden="true"
            class="fa fa-facebook-square"
          />Facebook</a>
        </li>
        <li @click="toggleShareMenu">
          <a
            id="xShare"
            :href="xUrl"
            target="_blank"
          ><i
            aria-hidden="true"
            class="fa fa-twitter-square"
          />X (Twitter)</a>
        </li>
        <li @click="toggleShareMenu">
          <a
            id="pinterestShare"
            :href="pinterestUrl"
            target="_blank"
          ><i
            aria-hidden="true"
            class="fa fa-pinterest-square"
          />Pinterest</a>
        </li>
        <li @click="toggleShareMenu">
          <a
            id="emailShare"
            :href="emailUrl"
          ><i
            aria-hidden="true"
            class="fa fa-envelope"
          />E-Mail</a>
        </li>
        <li @click="copyLink">
          <button
            id="copyLinkShare"
            class="copy-link"
          >
            <i
              aria-hidden="true"
              class="fa fa-link"
            />{{ $translate("Ecomsilio::Template.shareCopyLink") }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
    name: "BwShareButton",
    inject: {
        itemId: {
            default: null
        }
    },
    data ()
    {
        return {
            isShareMenuVisible: false
        }
    },
    computed: {
        currentVariation ()
        {
            return this.$store.getters[`${this.itemId}/currentItemVariation`]
        },
        currentURL ()
        {
            return "https://www.bundeswehr-und-mehr.de/a-" + this.itemId
        },
        facebookUrl ()
        {
            return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentURL)}`
        },
        xUrl ()
        {
            return `https://twitter.com/intent/tweet?url=${encodeURIComponent(this.currentURL)}&text=${encodeURIComponent(this.$options.filters.itemName(this.currentVariation))}`
        },
        pinterestUrl ()
        {
            return `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.currentURL)}`
        },
        emailUrl ()
        {
            return `mailto:?subject=${this.$translate("Ecomsilio::Template.shareLinkSubject")}&body=${encodeURIComponent(this.currentURL)}`
        }
    },
    mounted ()
    {
        document.addEventListener("click", this.handleClickOutside)
    },
    beforeDestroy ()
    {
        document.removeEventListener("click", this.handleClickOutside)
    },
    methods: {
        async handleShare ()
        {
            if (navigator.share)
            {
                await navigator.share({
                    title: this.$options.filters.itemName(this.currentVariation),
                    text: this.$translate("Ecomsilio::Template.shareLinkSubject"),
                    url: this.currentURL
                })
            }
            else
            {
                this.toggleShareMenu()
            }
        },
        toggleShareMenu ()
        {
            this.isShareMenuVisible = !this.isShareMenuVisible
        },
        async copyLink ()
        {
            await navigator.clipboard.writeText(this.currentURL)
            this.toggleShareMenu()
            alert(this.$translate("Ecomsilio::Template.shareLinkCopied"))
        },
        handleClickOutside (event)
        {
            if (this.isShareMenuVisible && this.$refs.shareWrapper && !this.$refs.shareWrapper.contains(event.target))
            {
                this.toggleShareMenu()
            }
        }
    }
}
</script>
